// ** React Imports
import { useMemo } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// #####################################################

const usePeriodFilterData = () => {
	const { t } = useTranslation(["common", "filtersAndSelectors"]);

	const language = useSelector((state) => state.globalCommon.language);

	const period = useSelector((state) => state.sharedFilters.period.period);

	// ** Filtr - Okres
	const sexPeriodData = useMemo(() => {
		const sexItemsText = () => {
			return !period || period === "latest"
				? t("filtersAndSelectors:period.latest")
				: period === "total"
				? t("filtersAndSelectors:period.total")
				: period
						.split("-")
						.map((part, index) =>
							index === 0 ? String(Number(part)) : part
						)
						.join(".");
		};
		return {
			label: t("filtersAndSelectors:periodLabel"),
			selected: sexItemsText(),
		};
	}, [period, language]);

	// #####################################################

	return sexPeriodData;
};

// #####################################################

export default usePeriodFilterData;

// #####################################################
